/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyTelegramLinkRequest
 */
export interface VerifyTelegramLinkRequest {
    /**
     * The unique, short-lived token received from the Telegram deep link's start parameter.
     * @type {string}
     * @memberof VerifyTelegramLinkRequest
     */
    token: string;
    /**
     * The unique Telegram User ID provided by the Telegram API for the user who clicked the link.
     * @type {string}
     * @memberof VerifyTelegramLinkRequest
     */
    telegramUserId: string;
}

/**
 * Check if a given object implements the VerifyTelegramLinkRequest interface.
 */
export function instanceOfVerifyTelegramLinkRequest(value: object): value is VerifyTelegramLinkRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('telegramUserId' in value) || value['telegramUserId'] === undefined) return false;
    return true;
}

export function VerifyTelegramLinkRequestFromJSON(json: any): VerifyTelegramLinkRequest {
    return VerifyTelegramLinkRequestFromJSONTyped(json, false);
}

export function VerifyTelegramLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyTelegramLinkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'telegramUserId': json['telegramUserId'],
    };
}

export function VerifyTelegramLinkRequestToJSON(json: any): VerifyTelegramLinkRequest {
    return VerifyTelegramLinkRequestToJSONTyped(json, false);
}

export function VerifyTelegramLinkRequestToJSONTyped(value?: VerifyTelegramLinkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'telegramUserId': value['telegramUserId'],
    };
}

